<template>
   <div id="pagetop">
      <!-- // Header -->
      <!-- // Header -->
      <header v-if="!isWatchStreamPage">
         <div class="container">
            <a class="logo" href="/" data-ratid=" kashiwasato_2020_toplogo " data-ratevent="click" data-ratparam="all"
               ><img src="@/assets/img/common/rakuten.svg" alt="Rakuten"
            /></a>
            <nav class="headerNav">
               <ul>
                  <li class="toroku">
                     <a
                        v-if="!isLoggedIn"
                        href=" https://www.rakuten.co.jp/myrakuten/help/"
                        target="_blank"
                        data-ratid=" kashiwasato_2020_idregister "
                        data-ratevent="click"
                        data-ratparam="all"
                        >楽天会員登録(無料)</a
                     >
                  </li>
                  <li class="login_b">
                     <a href="javascript:void(0)" @click="handleLogin">{{ isLoggedIn ? "ログアウト" : "ログイン" }}</a>
                  </li>
                  <li style="margin-left:5px"><a href="/chronicle">クロニクル</a></li>
                  <li style="margin-left:5px"><a href="/works">楽天展示作品</a></li>
               </ul>
            </nav>

            <div class="loginArea_sp">
               <a href="javascript:void(0)" @click="handleLogin">{{ isLoggedIn ? "ログアウト" : "ログイン" }}</a>
            </div>
            <!-- loginArea_sp -->

            <div class="sp_header_button">
               <a class="menu-trigger" href="javascript:void(0)" id="sp_menu_b">
                  <span></span>
                  <span></span>
                  <span></span>
               </a>
            </div>
            <!-- sp_header_button -->
         </div>
         <!-- container -->

         <nav class="sp_menuArea">
            <ul class="menuLink">
               <li class="lozad" data-toggle-class="fadeUp"><a href="/">TOP</a></li>
               <li class="lozad" data-toggle-class="fadeUp"><a href="/chronicle">クロニクル</a></li>
               <li class="lozad" data-toggle-class="fadeUp"><a href="/works">楽天展示作品</a></li>
               <li class="lozad" data-toggle-class="fadeUp">
                  <a href="https://kashiwasato2020.com/" target="_blank" data-ratid="kashiwasato_2020" data-ratevent="click" data-ratparam="all"
                     >佐藤可士和展</a
                  >
               </li>
               <li class="other sub lozad" data-toggle-class="fadeDown">
                  <a
                     v-if="!isLoggedIn"
                     href=" https://www.rakuten.co.jp/myrakuten/help/"
                     target="_blank"
                     data-ratid=" kashiwasato_2020_idregister "
                     data-ratevent="click"
                     data-ratparam="all"
                     >楽天会員登録(無料)</a
                  >
               </li>
            </ul>
         </nav>
         <!-- sp_menuArea -->
      </header>
      <!-- // Header -->

      <div class="app" :class="{ 'app--streaming': isWatchStreamPage }">
         <slot></slot>
      </div>

      <!-- // Footer -->
      <footer v-if="!isWatchStreamPage">
         <nav class="footer">
            <ul class="main">
               <li><a href="/">TOP</a></li>
               <li><a href="/chronicle">クロニクル</a></li>
               <li><a href="/works">楽天展示作品</a></li>
               <li>
                  <a href="https://kashiwasato2020.com/" target="_blank" data-ratid="kashiwasato_2020" data-ratevent="click" data-ratparam="all"
                     >佐藤可士和展</a
                  >
               </li>
            </ul>
            <ul class="sub">
               <li><a href="https://corp.rakuten.co.jp/security/" target="_blank">情報セキュリティの取り組み</a></li>
               <li><a href="https://privacy.rakuten.co.jp/" target="_blank">楽天グループ個人情報保護方針</a></li>
               <li><a href="https://corp.rakuten.co.jp/careers/privacy/" target="_blank">採用活動における個人情報保護方針</a></li>
               <li><a href="https://corp.rakuten.co.jp/disclaimer/" target="_blank">免責事項</a></li>
            </ul>
            <a class="pagetop" href="#pagetop"><img src="@/assets/img/common/pagetop_b.svg" alt="pagetop"/></a>
         </nav>
         <!-- footer -->
         <div class="copyright"><p>&copy;Rakuten,Inc.</p></div>
      </footer>
   </div>
</template>

<script>
import SdkMixins from "@/mixins/SdkMixins";
import { mapGetters } from "vuex";
import HelperMixins from "@/mixins/HelperMixins";
export default {
   name: "RakutenLayout",
   mixins: [SdkMixins, HelperMixins],
   props: {
      isWatchStreamPage: {
         type: Boolean,
         default: true
      }
   },
   mounted() {
      this.initScript(document, "script", { src: `${process.env.BASE_URL}vendor/assets/js/rf-main.js`, id: "rf-main" });
      this.initScript(document, "script", { src: `${process.env.BASE_URL}vendor/assets/js/main.js`, id: "main" });
   },
   computed: {
      ...mapGetters(["isLoggedIn"])
   },
   methods: {
      handleLogin() {
         if (this.isLoggedIn) this.logout();
         else window.location.href = this.getLoginURL;
      }
   }
};
</script>

<style lang="scss">
p {
   margin-bottom: 0;
}

#pagetop {
   .container {
      padding: 0;
   }
}

.loginArea_sp {
   @include respond(phone-xs) {
      right: 65px !important;
   }
}

.app {
   margin-top: 90px;
   min-height: $view-height;

   &--streaming {
      margin-top: 0;
      min-height: calc(((var(--vh, 1vh) * 100)));
   }
}

.logo {
   width: 200px !important;

   @include respond(phone-xs) {
      padding: 15px 5px !important;
   }

   @media screen and (max-width: 479px) {
      width: 180px !important;
   }

   img {
      width: 160px !important;
      @media screen and (max-width: 479px) {
         width: 140px !important;
      }
   }
}

.footer {
   .sub {
      margin-top: 10px;
   }
}

main.nakapage {
   background: url("../assets/img/pages/nakaheader.svg") center top repeat-x;
   background-size: 100%;
}
</style>
